const INITIAL_STATE = null;

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case 'SETVALIDACAO':
      state = action.validacao;
      return state;
    default:
      return state;
  }
};